// eslint-disable-next-line no-restricted-imports
import {
  LegalClientLegalHeadFragment,
  Query_LegalClientLegalHeadController_GetById_Status,
} from 'api/generated/graphql';
import { LegalClientLegalHeadEntity } from 'api/types/entity';
import { lodash } from 'helpers';

import { parseFileDocumentEntity } from '../client/parseEntity/parseFileEntity';
import { parseLegalClientFirstHeadItemEntity } from '../legal/parseEntity/innerItemEntity/parseLegalClientFirstHeadItemEntity';
import { parseLegalClientBodyEntity } from '../legal/parseEntity/parseLegalClientBodyEntity';
import { parseLegalClientLegalHeadStateRegistration } from '../legal/parseEntity/parseLegalClientLegalHeadStateRegistration';
import { parseLegalClientTaxResidency } from '../legal/parseEntity/parseLegalClientTaxResidency';
import { parseOrganizationalAndLegalFormEntity } from '../legal/parseEntity/parseOrganizationalAndLegalFormEntity';
import { parsePositionInCompanyEntity } from '../legalClientHead/parseEntity';
import { parseOboardingData } from '../parseOboardingData';

export const parseLegalClientLegalHeadEntity = (
  data: LegalClientLegalHeadFragment
): LegalClientLegalHeadEntity => ({
  id: data.id,
  versionNumber: data.version?.number,
  versionId: data.version?.id,
  fullName: data.fullName ?? undefined,
  shortName: data.shortName ?? undefined,
  legalClientId: data.legalClientId ?? undefined,
  deletedAt: data.deletedAt ? new Date(data.deletedAt) : undefined,
  legalAddress: data.legalAddress,
  actualAddress: data.actualAddress,
  archived:
    data.status ===
    Query_LegalClientLegalHeadController_GetById_Status.Archived,

  taxResidences: data.taxResidences
    ? lodash.compact(data.taxResidences).map(parseLegalClientTaxResidency)
    : undefined,

  stateRegistration: parseLegalClientLegalHeadStateRegistration(data),

  firstHeads: data.firstHeads
    ? lodash.compact(data.firstHeads).map(parseLegalClientFirstHeadItemEntity)
    : undefined,

  createdAt: new Date(data.createdAt),
  isFirstHead: data.isFirstHead ?? undefined,
  legalClientBodies: data.legalClientBodies
    ? lodash.compact(data.legalClientBodies).map(parseLegalClientBodyEntity)
    : undefined,
  onboarding: parseOboardingData(data.onboarding),

  position: data.positionInCompany
    ? parsePositionInCompanyEntity(data.positionInCompany)
    : undefined,
  additionalInformationFiles: lodash
    .compact(data.additionalInformationDocuments)
    .map(parseFileDocumentEntity),

  organizationalAndLegalForm: parseOrganizationalAndLegalFormEntity(
    data.organizationalAndLegalForm ?? undefined
  ),
  hasLegalClientBody: data.hasLegalClientBody ?? undefined,
});
